export const formatNumber = (x, lang) => {
  if (x) return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, lang === "ro" ? "." : ",");
  return "0";
};